import { Controller } from "@hotwired/stimulus"

import Stimulus from "../../common/utils/stimulus"

class FormField extends Controller {
  static targets = [`input`, `clear`]

  clear() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ``
      this.inputTarget.focus()
    }
  }
}

Stimulus.register(`form-field`, FormField)
